import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageMenu from "../../blocks/PageMenu/PageMenu";
import IconCrossGray from "../../../img/icons/svg/hamburger/cerrar-cruz-gris.svg";
import useCheckRecordStatusAndTypes from "../../../hooks/useCheckRecordStatusAndTypes";
import EntornoTrabajador from "../../../components/blocks/ManagementSheets/Administracion/EntornoTrabajador";
import ParteAltaBaja from "../../../components/blocks/ManagementSheets/Administracion/ParteAltaBaja";
import ParteConfirmacion from "../../../components/blocks/ManagementSheets/Administracion/ParteConfirmacion";
import ParteSinBaja from "../../../components/blocks/ManagementSheets/Administracion/ParteSinBaja";
import Recobro from "../../../components/blocks/ManagementSheets/Economico/Recobro";
import ReposicionOrtoprotesica from "../../../components/blocks/ManagementSheets/Economico/ReposicionOrtoprotesica";
import IMSResumen from "../../../components/blocks/ManagementSheets/Economico/ImsResumen";
import BaseCotizacionCata from "../../blocks/ManagementSheets/Economico/BaseCotizacionCata";
import ComisionPrestacionesEspeciales from "../../../components/blocks/ManagementSheets/Economico/ComisionPrestacionesEspeciales";
import GastosAsistencial from "../../../components/blocks/ManagementSheets/Economico/GastosAsistencial";
import BaseReguladora from "components/blocks/ManagementSheets/Economico/BaseReguladora";
import GastosJuridico from "components/blocks/ManagementSheets/Economico/GastosJuridico";
import CompensacionSLD from "../../blocks/ManagementSheets/Economico/CompensacionSLD";
import GastosTransporte from "components/blocks/ManagementSheets/Economico/GastosTransporte";
import Regularizacion from "components/blocks/ManagementSheets/Economico/Regularizacion";
import GastosFarmacia from "components/blocks/ManagementSheets/Economico/GastosFarmacia";
import PagoDirecto from "components/blocks/ManagementSheets/Economico/PagoDirecto";
interface IRecordDetailSheets { }

const RecordDetailSheets: React.FC<IRecordDetailSheets> = () => {
  const navigate = useNavigate();
  const { detailId } = useParams<{ detailId: string }>();
  const managementType = parseInt(detailId?.split("__")[0] || '0');
  const [titleParteAltaBaja, setTitleParteAltaBaja] = useState('');
  const { checkManagementType } = useCheckRecordStatusAndTypes();
  const tituloPateAltaBaja = (titulo: string) => {
    setTitleParteAltaBaja(titulo)
  }
  return (
    <>
      <PageMenu title={managementType === 1 ? titleParteAltaBaja : checkManagementType(managementType)}>
        <div className="btns-header-container">
          <button onClick={() => navigate(-1)}>
            <img src={IconCrossGray} alt="icon arrow right" />
          </button>
        </div>
      </PageMenu>
      <div>
        {managementType === 0 && <ParteConfirmacion  />}
        {managementType === 1 && <ParteAltaBaja tituloPateAltaBaja={tituloPateAltaBaja} />}
        {managementType === 2 && <ParteSinBaja />}
        {managementType === 3 && <EntornoTrabajador  />}
        {/* {managementType === 4 && <ReclamacionAdministrativa props={{}} />} */}
        {/* {managementType === 5 && <Litigio props={{}} />} */}
        {managementType === 100 && <BaseCotizacionCata />}
        {managementType === 101 && <BaseReguladora  />}
        {managementType === 102 && (<ComisionPrestacionesEspeciales />)}
        {managementType === 103 && <CompensacionSLD />}
        {managementType === 104 && <GastosAsistencial  />}
        {managementType === 105 && <GastosFarmacia  />}
        {managementType === 106 && <GastosJuridico />}
        {managementType === 107 && <GastosTransporte  />}
        {managementType === 108 && <Recobro />}
        {managementType === 109 && <Regularizacion  />}
        {managementType === 110 && <ReposicionOrtoprotesica/>}
        {managementType === 111 && <IMSResumen  />}
        {managementType === 112 && <PagoDirecto />}
      </div>
    </>
  );
};

export default RecordDetailSheets;
